<script setup lang="ts">
import type { LinkNavTab } from '@shared/ui/menus'

import { NavigationLinkTabs } from '@shared/ui/menus'

defineOptions({
  name: 'TutorKanbanDetailMenu',
})

const route = useRoute()
const tutorId = route.params.id as string

const basePath = `/tutor-kanban/${tutorId}`

const config: LinkNavTab[] = [
  {
    text: 'Info',
    to: `${basePath}/info`,
    selected: route.path === `${basePath}/info`,
    disabled: false,
    visible: true,
  },
  {
    text: 'Comments',
    to: `${basePath}/comments`,
    selected: route.path === `${basePath}/comments`,
    disabled: false,
    visible: true,
  },
  {
    text: 'Log',
    to: `${basePath}/log`,
    selected: route.path === `${basePath}/log`,
    disabled: false,
    visible: true,
  },
  {
    text: 'Time offs',
    to: `${basePath}/time-offs`,
    selected: route.path === `${basePath}/time-offs`,
    disabled: false,
    visible: true,
  },
]
</script>

<template>
  <NavigationLinkTabs :config="config" />
</template>
